/**
 * 🧩 VOBVOROT PUZZLE GAMIFICATION SYSTEM v2.0
 * Complete rewrite with VISIBLE triggers and amazing UX
 * All 12 puzzles with hints, visual feedback, and rewards
 */

(function() {
  'use strict';

  // ========================================
  // 🎯 PUZZLE DEFINITIONS (ALL 12 WITH VISIBLE TRIGGERS)
  // ========================================

  const PUZZLES = [
    {
      id: 'glitch-logo',
      name: '🌟 Glitch Logo Secret',
      hint: '💡 The vobvorot logo glitches every 15 seconds with pink/cyan flash... Click it during the glitch!',
      description: 'Caught the logo during its glitch moment',
      location: 'Header (any page)',
      points: 100,
      color: '#00FFFF',
      difficulty: '★★☆☆☆',
      secretCode: 'GLITCH2K'
    },
    {
      id: 'menu-triple',
      name: '💫 Menu Triple Click',
      hint: '💡 The menu button pulses with green light... Try clicking it 3 times quickly!',
      description: 'Mastered the triple-click menu secret',
      location: 'Header menu button',
      points: 100,
      color: '#39FF14',
      difficulty: '★★★☆☆'
    },
    {
      id: 'morse-code',
      name: '🎨 Neon Sign Morse Code',
      hint: '💡 The custom sign text flickers in morse code rhythm spelling "Y2K"... Click it during the flicker!',
      description: 'Decoded the morse code message',
      location: '"Your Name, My Pic" section',
      points: 150,
      color: '#FF1493',
      difficulty: '★★★★☆',
      discount: '10% off your first order'
    },
    {
      id: 'card-sequence',
      name: '🃏 Interactive Card Sequence',
      hint: '💡 Hover the 4 feature cards in this order: Community → Puzzle → Training → Letters (within 10 seconds)',
      description: 'Found the perfect card pattern',
      location: 'Interactive Features section',
      points: 200,
      color: '#8A2BE2',
      difficulty: '★★★★★',
      achievement: 'Pattern Master'
    },
    {
      id: 'letters-secret',
      name: '💌 Letters to Future Secret',
      hint: '💡 Start your letter with "dear vobvorot" to unlock a secret...',
      description: 'Sent a secret message to the future',
      location: 'Letters to Future modal',
      points: 100,
      color: '#00FFFF',
      difficulty: '★★☆☆☆',
      achievement: 'Time Traveler'
    },
    {
      id: 'music-sequence',
      name: '🎵 Music Player Secret Track',
      hint: '💡 Play the music tracks in this order: First → Last → Middle',
      description: 'Unlocked the secret playlist',
      location: 'Music Player',
      points: 150,
      color: '#FF1493',
      difficulty: '★★★★☆',
      secretPlaylist: true
    },
    {
      id: 'product-rainbow',
      name: '🛒 Product Hover Rainbow',
      hint: '💡 Quickly hover over 5 different product cards within 10 seconds to create a rainbow!',
      description: 'Created the product rainbow effect',
      location: 'Featured Products',
      points: 100,
      color: '#FFFF00',
      difficulty: '★★★☆☆',
      promoCode: 'RAINBOW10'
    },
    {
      id: 'time-easter',
      name: '⏰ Midnight Visitor',
      hint: '💡 Visit the website between 00:00 and 00:05 (midnight) to unlock this secret...',
      description: 'Became a midnight explorer',
      location: 'Any page (check footer time)',
      points: 200,
      color: '#8A2BE2',
      difficulty: '★★★★☆',
      achievement: 'Night Owl'
    },
    {
      id: 'footer-whisper',
      name: '📜 Footer Whisper Word',
      hint: '💡 Find the word that whispers in the footer copyright... it glows white when you hover!',
      description: 'Heard the whisper in the footer',
      location: 'Footer copyright text',
      points: 100,
      color: '#00FFFF',
      difficulty: '★★☆☆☆',
      quote: 'In the digital noise, whispers carry the deepest truth'
    },
    {
      id: 'konami-code',
      name: '🎮 The Legendary Code',
      hint: '💡 Try the famous cheat code: ↑↑↓↓←→←→BA',
      description: 'Unlocked the legendary Konami Code',
      location: 'Any page (keyboard)',
      points: 300,
      color: '#FFFF00',
      difficulty: '★★★★★',
      specialEffect: 'Rainbow Mode Activated!'
    },
    {
      id: 'scroll-perfect',
      name: '🔍 Perfect Balance',
      hint: '💡 Scroll to exactly 50% of the page and hold for 3 seconds... Watch the scroll indicator!',
      description: 'Achieved perfect scroll balance',
      location: 'Homepage (scroll indicator)',
      points: 150,
      color: '#FF1493',
      difficulty: '★★★★☆',
      achievement: 'Perfect Balance'
    },
    {
      id: 'url-secret',
      name: '🌐 URL Master Key',
      hint: '💡 Add ?secret=vobvorot2k or #y2k to the URL... (hint on /pages/puzzle page)',
      description: 'Discovered the master key URL parameter',
      location: 'Browser address bar',
      points: 200,
      color: '#39FF14',
      difficulty: '★★★☆☆',
      masterKey: true
    }
  ];

  // ========================================
  // 🏆 ACHIEVEMENT DEFINITIONS (8 TOTAL)
  // ========================================

  const ACHIEVEMENTS = [
    {
      id: 'first-steps',
      name: '🔍 First Steps',
      description: 'Found your first puzzle piece',
      requirement: 'Find 1 puzzle',
      points: 50,
      color: '#00FFFF'
    },
    {
      id: 'detective',
      name: '🕵️ Detective',
      description: 'Found 3 puzzle pieces',
      requirement: 'Find 3 puzzles',
      points: 50,
      color: '#8A2BE2',
      title: 'Detective'
    },
    {
      id: 'pattern-master',
      name: '🎯 Pattern Master',
      description: 'Found the Interactive Card Sequence',
      requirement: 'Complete card-sequence puzzle',
      points: 150,
      color: '#FF1493',
      badge: 'pattern-master-exclusive'
    },
    {
      id: 'night-owl',
      name: '⏰ Night Owl',
      description: 'Visited at midnight',
      requirement: 'Complete time-easter puzzle',
      points: 200,
      color: '#8A2BE2',
      themeUnlock: 'night-theme'
    },
    {
      id: 'speed-demon',
      name: '⚡ Speed Demon',
      description: 'Found 5 puzzles in 10 minutes',
      requirement: 'Find 5 puzzles within 10 minutes',
      points: 300,
      color: '#FFFF00',
      badge: 'speed-badge'
    },
    {
      id: 'secret-keeper',
      name: '🌈 Secret Keeper',
      description: 'Activated Rainbow Mode',
      requirement: 'Enter Konami Code',
      points: 200,
      color: '#FF1493',
      visualEffects: true
    },
    {
      id: 'puzzle-master',
      name: '📚 Puzzle Master',
      description: 'Found all 12 puzzles',
      requirement: 'Find all puzzles',
      points: 500,
      color: '#FFFF00',
      trophy: 'golden',
      discount: '15%'
    },
    {
      id: 'perfectionist',
      name: '💎 Perfectionist',
      description: 'Unlocked everything',
      requirement: 'All puzzles + all achievements',
      points: 1000,
      color: '#39FF14',
      badge: 'platinum',
      exclusiveAccess: true
    }
  ];

  // ========================================
  // 💾 STATE MANAGEMENT
  // ========================================

  let puzzleState = {
    foundPuzzles: [],
    unlockedAchievements: [],
    totalScore: 0,
    sessionStarted: new Date().toISOString(),
    puzzleTimestamps: {},
    // Tracking for specific puzzles
    cardHoverSequence: [],
    cardHoverStartTime: null,
    productHoverCount: 0,
    productHoverStartTime: null,
    musicTrackOrder: [],
    scrollPerfectTimeout: null,
    konamiSequence: [],
    menuClickCount: 0,
    menuClickTimeout: null
  };

  // ========================================
  // 🔧 CORE FUNCTIONS
  // ========================================

  function loadState() {
    try {
      const saved = localStorage.getItem('vobvorot-puzzle-v2');
      if (saved) {
        const savedState = JSON.parse(saved);
        puzzleState = { ...puzzleState, ...savedState };
        console.log('✅ Loaded puzzle state:', puzzleState.foundPuzzles.length, '/ 12 found');
      }
    } catch (error) {
      console.error('❌ Failed to load state:', error);
    }
  }

  function saveState() {
    try {
      localStorage.setItem('vobvorot-puzzle-v2', JSON.stringify(puzzleState));
    } catch (error) {
      console.error('❌ Failed to save state:', error);
    }
  }

  function findPuzzle(puzzleId) {
    // Check if already found
    if (puzzleState.foundPuzzles.includes(puzzleId)) {
      console.log('ℹ️ Puzzle already found:', puzzleId);
      return;
    }

    const puzzle = PUZZLES.find(p => p.id === puzzleId);
    if (!puzzle) {
      console.error('❌ Unknown puzzle:', puzzleId);
      return;
    }

    // Add to found list
    puzzleState.foundPuzzles.push(puzzleId);
    puzzleState.puzzleTimestamps[puzzleId] = new Date().toISOString();
    puzzleState.totalScore += puzzle.points;

    // Show celebration popup
    showPuzzleFoundPopup(puzzle);

    // Check achievements
    checkAchievements();

    // Save state
    saveState();

    // Dispatch event
    window.dispatchEvent(new CustomEvent('puzzle-found', {
      detail: { puzzle, state: getState() }
    }));

    console.log('🎉 Puzzle found!', puzzle.name, '→', puzzleState.foundPuzzles.length, '/ 12');
  }

  function checkAchievements() {
    const foundCount = puzzleState.foundPuzzles.length;

    // First Steps (1 puzzle)
    if (foundCount >= 1 && !puzzleState.unlockedAchievements.includes('first-steps')) {
      unlockAchievement('first-steps');
    }

    // Detective (3 puzzles)
    if (foundCount >= 3 && !puzzleState.unlockedAchievements.includes('detective')) {
      unlockAchievement('detective');
    }

    // Pattern Master (card sequence puzzle)
    if (puzzleState.foundPuzzles.includes('card-sequence') &&
        !puzzleState.unlockedAchievements.includes('pattern-master')) {
      unlockAchievement('pattern-master');
    }

    // Night Owl (midnight puzzle)
    if (puzzleState.foundPuzzles.includes('time-easter') &&
        !puzzleState.unlockedAchievements.includes('night-owl')) {
      unlockAchievement('night-owl');
    }

    // Secret Keeper (konami code)
    if (puzzleState.foundPuzzles.includes('konami-code') &&
        !puzzleState.unlockedAchievements.includes('secret-keeper')) {
      unlockAchievement('secret-keeper');
    }

    // Speed Demon (5 puzzles in 10 minutes)
    if (foundCount >= 5) {
      const timestamps = Object.values(puzzleState.puzzleTimestamps).slice(0, 5);
      const first = new Date(timestamps[0]);
      const fifth = new Date(timestamps[4]);
      const diffMinutes = (fifth - first) / 1000 / 60;

      if (diffMinutes <= 10 && !puzzleState.unlockedAchievements.includes('speed-demon')) {
        unlockAchievement('speed-demon');
      }
    }

    // Puzzle Master (all 12)
    if (foundCount === 12 && !puzzleState.unlockedAchievements.includes('puzzle-master')) {
      unlockAchievement('puzzle-master');
    }

    // Perfectionist (all puzzles + all achievements)
    if (foundCount === 12 && puzzleState.unlockedAchievements.length >= 7 &&
        !puzzleState.unlockedAchievements.includes('perfectionist')) {
      unlockAchievement('perfectionist');
    }
  }

  function unlockAchievement(achievementId) {
    if (puzzleState.unlockedAchievements.includes(achievementId)) return;

    const achievement = ACHIEVEMENTS.find(a => a.id === achievementId);
    if (!achievement) return;

    puzzleState.unlockedAchievements.push(achievementId);
    puzzleState.totalScore += achievement.points;

    showAchievementPopup(achievement);
    saveState();

    window.dispatchEvent(new CustomEvent('achievement-unlocked', {
      detail: { achievement, state: getState() }
    }));

    console.log('🏆 Achievement unlocked!', achievement.name);
  }

  // ========================================
  // 🎨 VISUAL FEEDBACK FUNCTIONS
  // ========================================

  function showPuzzleFoundPopup(puzzle) {
    const popup = document.createElement('div');
    popup.className = 'puzzle-found-popup';
    popup.innerHTML = `
      <div class="puzzle-popup-content">
        <div class="puzzle-popup-header" style="color: ${puzzle.color}">
          🧩 PUZZLE FOUND!
        </div>
        <div class="puzzle-popup-title">${puzzle.name}</div>
        <div class="puzzle-popup-description">${puzzle.description}</div>
        <div class="puzzle-popup-location">📍 ${puzzle.location}</div>
        <div class="puzzle-popup-points">+${puzzle.points} points</div>
        <div class="puzzle-popup-progress">
          ${puzzleState.foundPuzzles.length} / 12 puzzles found
        </div>
        ${puzzle.secretCode ? `<div class="puzzle-popup-code">🔐 Code: ${puzzle.secretCode}</div>` : ''}
        ${puzzle.discount ? `<div class="puzzle-popup-reward">🎁 Reward: ${puzzle.discount}</div>` : ''}
      </div>
    `;

    // Add styles
    const style = document.createElement('style');
    style.textContent = `
      .puzzle-found-popup {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
        border: 2px solid ${puzzle.color};
        border-radius: 15px;
        padding: 2rem;
        z-index: 10001;
        animation: popupAppear 0.5s ease;
        box-shadow: 0 0 50px ${puzzle.color}80;
        max-width: 90%;
        width: 400px;
      }
      .puzzle-popup-content {
        text-align: center;
        font-family: 'JetBrains Mono', monospace;
      }
      .puzzle-popup-header {
        font-size: 1.5rem;
        font-weight: bold;
        margin-bottom: 1rem;
        text-shadow: 0 0 10px currentColor;
      }
      .puzzle-popup-title {
        font-size: 1.2rem;
        color: #fff;
        margin-bottom: 0.5rem;
      }
      .puzzle-popup-description {
        color: #aaa;
        margin-bottom: 1rem;
        font-size: 0.9rem;
      }
      .puzzle-popup-location {
        color: #666;
        font-size: 0.8rem;
        margin-bottom: 0.5rem;
      }
      .puzzle-popup-points {
        color: ${puzzle.color};
        font-size: 1.5rem;
        font-weight: bold;
        margin: 1rem 0;
      }
      .puzzle-popup-progress {
        color: #999;
        font-size: 0.9rem;
        margin-bottom: 1rem;
      }
      .puzzle-popup-code, .puzzle-popup-reward {
        background: rgba(255,255,255,0.1);
        padding: 0.5rem;
        border-radius: 5px;
        margin-top: 0.5rem;
        color: #fff;
      }
      @keyframes popupAppear {
        from {
          opacity: 0;
          transform: translate(-50%, -50%) scale(0.5);
        }
        to {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1);
        }
      }

      /* Mobile styles - уменьшенный popup */
      @media (max-width: 768px) {
        .puzzle-found-popup {
          padding: 1rem;
          width: 280px;
          border-radius: 10px;
        }
        .puzzle-popup-header {
          font-size: 1rem;
          margin-bottom: 0.5rem;
        }
        .puzzle-popup-title {
          font-size: 0.9rem;
          margin-bottom: 0.3rem;
        }
        .puzzle-popup-description {
          font-size: 0.75rem;
          margin-bottom: 0.5rem;
        }
        .puzzle-popup-location {
          font-size: 0.65rem;
          margin-bottom: 0.3rem;
        }
        .puzzle-popup-points {
          font-size: 1.1rem;
          margin: 0.5rem 0;
        }
        .puzzle-popup-progress {
          font-size: 0.7rem;
          margin-bottom: 0.5rem;
        }
        .puzzle-popup-code, .puzzle-popup-reward {
          padding: 0.3rem;
          font-size: 0.7rem;
        }
      }
    `;
    document.head.appendChild(style);
    document.body.appendChild(popup);

    // Particle effect
    createParticles(puzzle.color);

    // Auto-remove after 4 seconds
    setTimeout(() => {
      popup.remove();
      style.remove();
    }, 4000);
  }

  function showAchievementPopup(achievement) {
    const popup = document.createElement('div');
    popup.className = 'achievement-popup';
    popup.innerHTML = `
      <div class="achievement-popup-content">
        <div class="achievement-popup-icon">${achievement.name.split(' ')[0]}</div>
        <div class="achievement-popup-title">${achievement.name}</div>
        <div class="achievement-popup-description">${achievement.description}</div>
        <div class="achievement-popup-points">+${achievement.points} points</div>
      </div>
    `;

    const style = document.createElement('style');
    style.textContent = `
      .achievement-popup {
        position: fixed;
        top: 20px;
        right: 20px;
        background: linear-gradient(45deg, #FFFF00, #FF1493);
        color: #000;
        padding: 1rem 1.5rem;
        border-radius: 10px;
        font-weight: bold;
        z-index: 10000;
        animation: achievementSlide 0.5s ease;
        box-shadow: 0 0 30px rgba(255,255,255,0.5);
        font-family: 'JetBrains Mono', monospace;
      }
      .achievement-popup-content {
        text-align: center;
      }
      .achievement-popup-icon {
        font-size: 2rem;
        margin-bottom: 0.5rem;
      }
      .achievement-popup-title {
        font-size: 1.1rem;
        margin-bottom: 0.25rem;
      }
      .achievement-popup-description {
        font-size: 0.8rem;
        opacity: 0.8;
      }
      .achievement-popup-points {
        margin-top: 0.5rem;
        font-size: 1rem;
      }
      @keyframes achievementSlide {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
    `;
    document.head.appendChild(style);
    document.body.appendChild(popup);

    setTimeout(() => {
      popup.remove();
      style.remove();
    }, 4000);
  }

  function createParticles(color) {
    for (let i = 0; i < 20; i++) {
      const particle = document.createElement('div');
      particle.className = 'puzzle-particle';
      particle.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        width: 10px;
        height: 10px;
        background: ${color};
        border-radius: 50%;
        pointer-events: none;
        z-index: 10002;
        animation: particleBurst 1s ease-out forwards;
      `;

      const angle = (Math.PI * 2 * i) / 20;
      const distance = 100 + Math.random() * 100;
      const x = Math.cos(angle) * distance;
      const y = Math.sin(angle) * distance;

      particle.style.setProperty('--x', x + 'px');
      particle.style.setProperty('--y', y + 'px');

      document.body.appendChild(particle);

      setTimeout(() => particle.remove(), 1000);
    }

    const style = document.createElement('style');
    style.textContent = `
      @keyframes particleBurst {
        to {
          transform: translate(var(--x), var(--y));
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
    setTimeout(() => style.remove(), 1000);
  }

  // ========================================
  // 🎯 PUZZLE TRIGGER FUNCTIONS
  // ========================================

  // 1. GLITCH LOGO - Logo flashes every 15 seconds
  function initGlitchLogo() {
    const logos = document.querySelectorAll('.header__logo, .header__logo-text, h1');
    if (logos.length === 0) return;

    // Add glitch animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes logoGlitch {
        0%, 90%, 100% {
          filter: none;
          transform: none;
        }
        92% {
          filter: hue-rotate(120deg);
          transform: translateX(-2px);
        }
        94% {
          filter: hue-rotate(240deg);
          transform: translateX(2px);
        }
        96% {
          filter: hue-rotate(360deg);
          transform: translateX(-1px);
        }
      }
      .logo-glitching {
        animation: logoGlitch 0.5s ease !important;
        cursor: pointer !important;
      }
    `;
    document.head.appendChild(style);

    // Glitch every 15 seconds
    setInterval(() => {
      logos.forEach(logo => {
        logo.classList.add('logo-glitching');
        setTimeout(() => logo.classList.remove('logo-glitching'), 500);
      });
    }, 15000);

    // Click during glitch
    logos.forEach(logo => {
      logo.addEventListener('click', function() {
        if (this.classList.contains('logo-glitching')) {
          findPuzzle('glitch-logo');
        }
      });
    });
  }

  // 2. MENU TRIPLE CLICK - Menu button pulses, triple click it
  function initMenuTripleClick() {
    const menuBtn = document.querySelector('.menu-toggle, .header__menu-toggle, [aria-label*="menu"]');
    if (!menuBtn) return;

    // Add pulse animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes menuPulse {
        0%, 100% { box-shadow: 0 0 0 0 rgba(57, 255, 20, 0.7); }
        50% { box-shadow: 0 0 20px 10px rgba(57, 255, 20, 0); }
      }
      .menu-pulsing {
        animation: menuPulse 2s infinite !important;
      }
    `;
    document.head.appendChild(style);
    menuBtn.classList.add('menu-pulsing');

    let clicks = 0;
    let clickTimeout;

    menuBtn.addEventListener('click', function(e) {
      clicks++;

      clearTimeout(clickTimeout);
      clickTimeout = setTimeout(() => {
        if (clicks === 3) {
          e.preventDefault();
          e.stopPropagation();
          findPuzzle('menu-triple');
          menuBtn.classList.remove('menu-pulsing');
        }
        clicks = 0;
      }, 500);
    }, true);
  }

  // 3. MORSE CODE - Text flickers in morse pattern
  function initMorseCode() {
    const signText = document.querySelector('.sign-text, .sign-description, .custom-sign');
    if (!signText) return;

    // Y2K in morse: -.-- ..--- -.-
    const morsePattern = [
      200, 100, 600, 100, 200, 100, 200, 400, // Y
      100, 100, 600, 100, 600, 100, 600, 100, 600, 400, // 2
      200, 100, 200, 100, 600, 100, 200 // K
    ];

    const style = document.createElement('style');
    style.textContent = `
      .morse-flickering {
        animation: morseFlicker 5s ease-in-out !important;
        cursor: pointer !important;
      }
      @keyframes morseFlicker {
        ${morsePattern.map((duration, i) => {
          const percent = (morsePattern.slice(0, i).reduce((a,b) => a + b, 0) / morsePattern.reduce((a,b) => a + b, 0)) * 100;
          return `${percent}% { opacity: ${i % 2 === 0 ? '0.3' : '1'}; }`;
        }).join('\n')}
      }
    `;
    document.head.appendChild(style);

    // Flicker every 20 seconds
    setInterval(() => {
      signText.classList.add('morse-flickering');
      setTimeout(() => signText.classList.remove('morse-flickering'), 5000);
    }, 20000);

    signText.addEventListener('click', function() {
      if (this.classList.contains('morse-flickering')) {
        findPuzzle('morse-code');
      }
    });
  }

  // 4. CARD SEQUENCE - Hover cards in order: Community → Puzzle → Training → Letters
  function initCardSequence() {
    const cards = document.querySelectorAll('.feature-card');
    if (cards.length < 4) return;

    const correctOrder = ['community', 'puzzle', 'training', 'letters'];

    cards.forEach((card, index) => {
      const title = card.querySelector('.feature-title');
      if (!title) return;

      const text = title.textContent.toLowerCase();
      let cardType = '';
      if (text.includes('community')) cardType = 'community';
      else if (text.includes('puzzle')) cardType = 'puzzle';
      else if (text.includes('training')) cardType = 'training';
      else if (text.includes('letter')) cardType = 'letters';

      card.dataset.cardType = cardType;

      card.addEventListener('mouseenter', function() {
        const now = Date.now();

        // Reset if too slow
        if (puzzleState.cardHoverStartTime && (now - puzzleState.cardHoverStartTime > 10000)) {
          puzzleState.cardHoverSequence = [];
          puzzleState.cardHoverStartTime = null;
        }

        // Start tracking
        if (!puzzleState.cardHoverStartTime) {
          puzzleState.cardHoverStartTime = now;
        }

        // Add to sequence
        if (!puzzleState.cardHoverSequence.includes(cardType)) {
          puzzleState.cardHoverSequence.push(cardType);
          card.style.boxShadow = '0 0 20px #39FF14';

          // Check if complete
          if (puzzleState.cardHoverSequence.length === 4) {
            const isCorrect = puzzleState.cardHoverSequence.every((type, i) => type === correctOrder[i]);
            if (isCorrect) {
              findPuzzle('card-sequence');
            }
            puzzleState.cardHoverSequence = [];
            puzzleState.cardHoverStartTime = null;
          }
        }
      });
    });
  }

  // 5. LETTERS SECRET - Start with "dear vobvorot"
  function initLettersSecret() {
    document.addEventListener('input', function(e) {
      const target = e.target;
      if (target.tagName === 'TEXTAREA' || (target.tagName === 'INPUT' && target.type === 'text')) {
        const text = target.value.toLowerCase().trim();
        if (text.startsWith('dear vobvorot')) {
          findPuzzle('letters-secret');
          unlockAchievement('time-traveler');
        }
      }
    });
  }

  // 6. MUSIC SEQUENCE - Play first → last → middle
  function initMusicSequence() {
    document.addEventListener('music-track-played', function(e) {
      const trackIndex = e.detail?.trackIndex;
      const totalTracks = e.detail?.totalTracks || 3;

      if (trackIndex !== undefined) {
        puzzleState.musicTrackOrder.push(trackIndex);

        if (puzzleState.musicTrackOrder.length === 3) {
          const middle = Math.floor(totalTracks / 2);
          const correctOrder = [0, totalTracks - 1, middle];
          const isCorrect = puzzleState.musicTrackOrder.every((track, i) => track === correctOrder[i]);

          if (isCorrect) {
            findPuzzle('music-sequence');
          }

          puzzleState.musicTrackOrder = [];
        }
      }
    });
  }

  // 7. PRODUCT RAINBOW - Hover 5 products in 10 seconds
  function initProductRainbow() {
    const products = document.querySelectorAll('.product-card, .featured-product, [class*="product"]');

    products.forEach(product => {
      product.addEventListener('mouseenter', function() {
        const now = Date.now();

        if (!puzzleState.productHoverStartTime) {
          puzzleState.productHoverStartTime = now;
          puzzleState.productHoverCount = 0;
        }

        if (now - puzzleState.productHoverStartTime <= 10000) {
          puzzleState.productHoverCount++;
          // NO VISUAL EFFECT - just track hovers silently

          if (puzzleState.productHoverCount >= 5) {
            findPuzzle('product-rainbow');
            puzzleState.productHoverCount = 0;
            puzzleState.productHoverStartTime = null;
          }
        } else {
          puzzleState.productHoverCount = 1;
          puzzleState.productHoverStartTime = now;
        }
      });
    });
  }

  // 8. TIME EASTER EGG - Visit between 00:00-00:05
  function initTimeEasterEgg() {
    const now = new Date();
    const hour = now.getHours();
    const minute = now.getMinutes();

    if (hour === 0 && minute <= 5) {
      setTimeout(() => {
        findPuzzle('time-easter');
        unlockAchievement('night-owl');
      }, 2000);
    }

    // NO VISUAL TIME DISPLAY - it breaks footer layout!
    // Puzzle works without showing time
  }

  // 9. FOOTER WHISPER - Find and wrap EXISTING "whisper" word in copyright
  function initFooterWhisper() {
    const footer = document.querySelector('.footer, footer, .footer-content');
    if (!footer) return;

    // Find copyright paragraph - it contains "whisper of God"
    const textElements = footer.querySelectorAll('.footer__copyright p, p');
    let whisperAdded = false;

    textElements.forEach(el => {
      const text = el.textContent.trim();

      // Only process elements that contain copyright text AND the word "whisper"
      if (text.includes('©') && text.includes('whisper') && !whisperAdded) {
        // Use safe DOM manipulation instead of innerHTML to avoid breaking HTML
        const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
        let node;

        while (node = walker.nextNode()) {
          const nodeText = node.textContent;
          const whisperIndex = nodeText.toLowerCase().indexOf('whisper');

          if (whisperIndex !== -1) {
            // Found the word, split and wrap it safely
            const before = nodeText.substring(0, whisperIndex);
            const word = nodeText.substring(whisperIndex, whisperIndex + 7);
            const after = nodeText.substring(whisperIndex + 7);

            const span = document.createElement('span');
            span.className = 'whisper-word';
            span.style.cssText = 'cursor: pointer; transition: all 0.3s;';
            span.textContent = word;

            const fragment = document.createDocumentFragment();
            if (before) fragment.appendChild(document.createTextNode(before));
            fragment.appendChild(span);
            if (after) fragment.appendChild(document.createTextNode(after));

            node.parentNode.replaceChild(fragment, node);
            whisperAdded = true;
            break;
          }
        }
      }
    });

    // Add glow effect
    const style = document.createElement('style');
    style.textContent = `
      .whisper-word {
        color: inherit;
        transition: all 0.3s ease;
      }
      .whisper-word:hover {
        color: #00FF41 !important;
        text-shadow: 0 0 10px #00FF41;
      }
    `;
    document.head.appendChild(style);

    // Click listener
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('whisper-word')) {
        findPuzzle('footer-whisper');
        e.target.style.display = 'none';
      }
    });
  }

  // 10. KONAMI CODE - Classic ↑↑↓↓←→←→BA with RAINBOW MODE (NO BANNER!)
  function initKonamiCode() {
    const konamiSequence = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
    let userSequence = [];

    document.addEventListener('keydown', function(e) {
      const key = e.key === 'b' || e.key === 'a' ? e.key.toLowerCase() : e.key;

      userSequence.push(key);

      // Keep only last 10 keys
      if (userSequence.length > 10) {
        userSequence.shift();
      }

      // Check if matches
      const matches = userSequence.every((k, i) => k === konamiSequence[i]);

      if (matches && userSequence.length === 10) {
        findPuzzle('konami-code');
        unlockAchievement('secret-keeper');
        activateRainbowMode();
        userSequence = [];
      }
    });
  }

  function activateRainbowMode() {
    // NO BANNER! Only beautiful rainbow effect!
    const style = document.createElement('style');
    style.textContent = `
      @keyframes rainbowMode {
        0% { filter: hue-rotate(0deg); }
        100% { filter: hue-rotate(360deg); }
      }
    `;
    document.head.appendChild(style);

    document.body.style.animation = 'rainbowMode 5s ease-in-out';

    setTimeout(() => {
      document.body.style.animation = '';
      style.remove();
    }, 5000);

    console.log('🌈 RAINBOW MODE ACTIVATED!');
  }

  // 11. SCROLL PERFECT - Scroll to 50% and hold 3 seconds
  function initScrollPerfect() {
    // NO VISUAL INDICATOR - just track scroll position silently
    window.addEventListener('scroll', function() {
      const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;

      // Check if at 50% (+/- 2%)
      if (scrollPercent >= 48 && scrollPercent <= 52) {
        if (puzzleState.scrollPerfectTimeout) {
          clearTimeout(puzzleState.scrollPerfectTimeout);
        }

        puzzleState.scrollPerfectTimeout = setTimeout(() => {
          findPuzzle('scroll-perfect');
          unlockAchievement('perfect-balance');
        }, 3000);
      } else {
        if (puzzleState.scrollPerfectTimeout) {
          clearTimeout(puzzleState.scrollPerfectTimeout);
          puzzleState.scrollPerfectTimeout = null;
        }
      }
    });
  }

  // 12. URL SECRET - Check for ?secret=vobvorot2k or #y2k
  function initURLSecret() {
    const url = window.location.href;

    if (url.includes('?secret=vobvorot2k') || url.includes('#y2k')) {
      setTimeout(() => {
        findPuzzle('url-secret');
      }, 1000);
    }
  }

  // ========================================
  // 🌐 GLOBAL API
  // ========================================

  function getState() {
    return {
      puzzles: PUZZLES.map(p => ({
        ...p,
        found: puzzleState.foundPuzzles.includes(p.id),
        foundAt: puzzleState.puzzleTimestamps[p.id] || null
      })),
      achievements: ACHIEVEMENTS.map(a => ({
        ...a,
        unlocked: puzzleState.unlockedAchievements.includes(a.id)
      })),
      stats: {
        totalScore: puzzleState.totalScore,
        foundPuzzles: puzzleState.foundPuzzles.length,
        totalPuzzles: PUZZLES.length,
        unlockedAchievements: puzzleState.unlockedAchievements.length,
        totalAchievements: ACHIEVEMENTS.length,
        completionPercent: (puzzleState.foundPuzzles.length / PUZZLES.length * 100).toFixed(1)
      }
    };
  }

  window.vobvorotPuzzle = {
    // Core functions
    findPuzzle: findPuzzle,
    unlockAchievement: unlockAchievement,
    getState: getState,
    resetProgress: () => {
      if (confirm('🚨 Reset all puzzle progress? This cannot be undone!')) {
        sessionStorage.removeItem('vobvorot-puzzle-v2');
        window.location.reload();
      }
    },

    // Trigger functions for external use
    triggerCardHover: (cardType) => {
      puzzleState.cardHoverSequence.push(cardType);
    },
    triggerProductHover: () => {
      puzzleState.productHoverCount++;
    },
    triggerMusicTrack: (trackIndex, totalTracks) => {
      window.dispatchEvent(new CustomEvent('music-track-played', {
        detail: { trackIndex, totalTracks }
      }));
    }
  };

  // ========================================
  // 🚀 INITIALIZATION
  // ========================================

  function init() {
    console.log('🧩 VOBVOROT Puzzle System v2.0 Initializing...');

    loadState();

    // Initialize all puzzle triggers
    initGlitchLogo();
    initMenuTripleClick();
    initMorseCode();
    initCardSequence();
    initLettersSecret();
    initMusicSequence();
    initProductRainbow();
    initTimeEasterEgg();
    initFooterWhisper();
    initKonamiCode();
    initScrollPerfect();
    initURLSecret();

    console.log('✅ All 12 puzzle triggers active!');
    console.log('📊 Progress:', puzzleState.foundPuzzles.length, '/ 12 puzzles found');
    console.log('🏆 Achievements:', puzzleState.unlockedAchievements.length, '/ 8 unlocked');
    console.log('💎 Total Score:', puzzleState.totalScore);

    // Auto-check time easter egg every minute
    setInterval(initTimeEasterEgg, 60000);
  }

  // Start when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
